import { render, staticRenderFns } from "./BloqueGeocerca.vue?vue&type=template&id=ca492624"
import script from "./BloqueGeocerca.vue?vue&type=script&lang=js"
export * from "./BloqueGeocerca.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports